import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { msg } from 'api';

import FopInfoBox from 'widgets/FopInfoBox/FopInfoBox';
import createMarkup from 'utils/createMarkup';

export default class SubscriptionsTrolleyInfoBoxContainer extends PureComponent {
  static propTypes = {
    showTrolleyInfoBox: PropTypes.bool.isRequired,
    onDismiss: PropTypes.func.isRequired,
  };

  render() {
    const { onDismiss, showTrolleyInfoBox } = this.props;

    if (!showTrolleyInfoBox) {
      return null;
    }

    return (
      <FopInfoBox
        className="subL-trolleyInfoBox"
        onDismiss={onDismiss}
      >
        <p className="subL-trolleyInfoBox__title">
          <strong dangerouslySetInnerHTML={createMarkup(msg.subscriptions.trolleyInfobox.title)} />
        </p>
        <p className="subL-trolleyInfoBox__content">
          {msg.subscriptions.trolleyInfobox.content}
          {' '}
          <a className="subL-trolleyInfoBox__link" href="/subscriptions">{msg.subscriptions.trolleyInfobox.link}</a>
        </p>
      </FopInfoBox>
    );
  }
}
